<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" showPanel="true" (cwInfiniteScroll)="getNextBatch()">
  <app-grid-spinner #spinner></app-grid-spinner>
  <div class="scroll-area">
    <div *ngIf="MultiSelection; else exclude_plan_id">
      <mat-option *ngFor="let option of options$ | async"  [disabled]="option.disabled" [value]="selectedValue">
        <div (click)="optionClicked($event, option)">
          <mat-checkbox [checked]="option.selected" (change)="toggleSelection(option)" [disabled]="option.disabled" (click)="$event.stopPropagation()">
            {{option.description}}
          </mat-checkbox>         
        </div>
      </mat-option>
    </div>
    <ng-template #exclude_plan_id>
        <mat-option *ngFor="let option of options$ | async" [value]="option" [disabled]="option.disabled">
          <div [ngClass]="(!option.isValid)? 'inValidInstance': ''"> 
            {{option.description}}
          </div>
        </mat-option>
    </ng-template>
    </div>
</mat-autocomplete>